<template>
    <div class="flats-crm-items-container flats-items-list" v-if="flatsItems != null">
        <div class="flats-empty-msg" v-if="flatsEmptyMsg"><p>По данному запросу квартир в продаже не найдено</p></div>
        <div class="flat-cards-items-list-info" v-if="!flatsEmptyMsg && !mobileView">
            <ul>
                <div class="left">
                    <li><p>{{flatsWords.flats_cards_info.flat_plan_name}}</p></li>
                </div>
                <div class="center">
                    <li><p>{{flatsWords.flats_cards_info.flat_rooms}}</p></li>
                    <li><p>{{flatsWords.flats_cards_info.flat_floor}}</p></li>
                    <li><p>{{flatsWords.flats_cards_info.flat_size}}</p></li>
                    <li v-if="salesCard.site_shablon_price_init == 'true'"><p>{{flatsWords.flats_cards_info.flat_price}} <span>м²</span></p></li>
                    <li><p>{{flatsWords.flats_cards_info.flat_number}}</p></li>
                    <li><p>{{flatsWords.flats_cards_info.flat_bloom}}</p></li>
                </div>
                <div class="right" v-if="salesCard.site_shablon_online_booking_init == 'true'">
                    <li><p>{{flatsWords.flats_cards_info.flat_you_can_name}}</p></li>
                </div>
            </ul>
        </div>
        <div class="flats-items-list-loop" v-if="!flatsEmptyMsg">
            <div class="flat-item" v-for="item in flatsItems" :key="item.id" :class="{'small' : salesCard.site_shablon_online_booking_init == 'false'}">
                <a href="#" @click.prevent="openCrmFlatModal(item)" class="item-link-main">
                    <div class="item-default item-img" v-if="item != null && item.id != null && item.images.length > 0">
                        <div class="img-in">
                            <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in item.images.filter(item => item.typeCode === '1')" :key="index">
                        </div>
                    </div>
                    <div class="item-info">
                        <ul>
                            <li>
                                {{item.rooms}}
                                <p v-if="mobileView">{{flatsWords.flats_cards_info.flat_rooms}}</p>
                            </li>
                            <li>
                                {{item.floor}}
                                <p v-if="mobileView">{{flatsWords.flats_cards_info.flat_floor}}</p>
                            </li>
                            <li>
                                {{item.area}} <span>м²</span>
                                <p v-if="mobileView">{{flatsWords.flats_cards_info.flat_size}}</p>
                            </li>
                            <li class="price" v-if="salesCard.site_shablon_price_init == 'true' && item.showPricesOnSaleSite == true">
                                <strong><span>от</span> {{getNumber(item.meterPrice)}} <span v-if="!mobileView">тг.</span></strong>
                                <p v-if="mobileView">{{flatsWords.flats_cards_info.flat_price}} <span>тг. м²</span></p>
                            </li>
                            <li>
                                {{item.number}}
                                <p v-if="mobileView">{{flatsWords.flats_cards_info.flat_flat_number}}</p>
                            </li>
                            <li>
                                <!-- {{getNumbersOfString(item.blockName)}} -->
                                <div class="blockname" v-if="item.complexCode != 'DSV' && item.complexCode != 'SOH' && projectHost != 'lmgold' && projectHost != 'level' && projectHost != 'grandmonaco' && projectHost != 'elios'">
                                    {{getNumbersOfString(item.blockName)}}
                                </div>
                                <div class="blockname" v-if="item.complexCode == 'DSV' || projectHost == 'lmgold' || projectHost == 'grandmonaco' || projectHost == 'elios'">
                                    {{getNumbersOfBlockDiscovery(item.blockName)}}
                                </div>
                                <div class="blockname" v-if="item.complexCode == 'SOH'">
                                    {{getNumbersOfBlockSoho(item.blockName)}}
                                </div>
                                <p v-if="mobileView && item.complexCode != 'SOH'">{{flatsWords.flats_cards_info.flat_bloom}}</p>
                                <p v-if="mobileView && item.complexCode == 'SOH'">{{flatsWords.flats_cards_info.flat_kvartal}}</p>
                            </li>
                        </ul>
                    </div>
                </a>
                <div class="item-btns" v-if="salesCard.site_shablon_online_booking_init == 'true'">
                    <div>
                        <a 
                            :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=book'" class="bron" target="_blank" 
                            v-if="item.isApartmentReserved"
                            >{{flatsWords.flats_cards_info.flat_btn_book_name}}
                        </a>
                        <span v-else class="btn-off bron-off">{{flatsWords.flats_cards_info.flat_btn_book_name}}</span>
                        <a 
                        :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=by'" class="by" target="_blank" 
                            v-if="item.hasJointVentureAgreement"
                            >{{flatsWords.flats_cards_info.flat_btn_by_name}}
                        </a>
                        <span v-else class="btn-off by-off">{{flatsWords.flats_cards_info.flat_btn_by_name}}</span>
                    </div>
                    <div class="hypothec-btn" :class="{'disabled-link' : !item.hasMortgage}" v-if="salesCard.site_shablon_hypothec_init != null && salesCard.site_shablon_hypothec_init == 'true'">
                        <a 
                            :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=mortgage'" class="mortgage" target="_blank" 
                            v-if="item.hasMortgage"
                            >{{flatsWords.flats_cards_info.flat_btn_hypothec_online_name}}
                        </a>
                        <span v-else class="btn-off">{{ flatsWords.flats_cards_info.flat_btn_hypothec_online_name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'flats-items-list',
        props: ['mobileView'],
        components: {
        },
        data () {
            return {
                projectHost: window.host,
                blockPart: null,
            }
        },
        methods: {
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockLandmark(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getNumbersOfBlockMonaco(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '').replace(/ /g, '');
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            getBlockPartLDM(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = parseInt(blockPart);
                return blockPart;
            },
            getBlockPartSOH(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = blockPart.replace('Блок', '');
                blockPart = blockPart.replace(/ /g, '');
                return blockPart;
            },
            getBlockPartMNC(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = blockPart.replace('Блок', '');
                blockPart = blockPart.replace(/ /g, '');
                return blockPart;
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            openCrmFlatModal(arr) {
                this.$store.commit('modalData', arr);
                setTimeout(() => {
                    this.$modal.show('sales_land_flat_card_crm_modal');
                }, 300);
            },
            getPriceForm() {

            },
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
            openFormModal(param) {
                this.$store.commit('Open_Form_Modal', param);
            },
            checkConfirmPurchase(param, code, blockName) {
                // console.log(param, code, blockName)
                if (code != 'DSV' && code != 'LDM-3' && code != 'SOH' && code != 'MNC') {
                    blockName = this.getNumbersOfString(blockName);
                } else if (code == 'DSV') { 
                    blockName = parseInt(this.getNumbersOfBlockDiscovery(blockName));
                } 
                // else if (code == 'LDM') {
                //     blockName = parseInt(this.getNumbersOfBlockLandmark(blockName));
                // } else if (code == 'SOH') {
                //     blockName = this.getNumbersOfBlockSoho(blockName);
                // } else if (code == 'MNC') {
                //     blockName = this.getNumbersOfBlockMonaco(blockName);
                // }
                // console.log(blockName, this.blockPart)

                if (param == 'book') { //////////////////////////////////////////////////////////  BOOK   ////////////////////////////////////////////////////////////////////////
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        return false;
                    }
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок DISCOVERY
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                } else if (param == 'by') { ///////////////////////////////////////////////////////    BY    ///////////////////////////////////////////////////////////////////////
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        return false;
                    }
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок DISCOVERY
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                } else {
                    return false;
                }
            },
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            flatsWords: 'loadFlatsWords',
            flatsItems: 'loadFlatsItems',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-items-list.scss';
    @import '@/styles/components/flats-crm/flats-crm-items-main.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-list-respond.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-main-respond.scss';
    // @import '@/styles/components/flats-page/respond/flats-item-respond.scss';
</style>